
<template>
  <div>
    <Head title="會員中心 - 獎勵/購物金查詢 - 各期明細" />
    <rebate-template title="會員中心">
      <template #header>
        <Link
          :href="route('user.rebates')"
          class="flex flex-row items-center text-lg"
        >
          <i class="pi pi-chevron-left mr-2" /> 獎勵/購物金查詢
        </Link>
        <div class="text-center" v-if="route().current('user.rebates.rebate')">
          獎勵金明細
        </div>
        <div class="text-center" v-else>購物金明細</div>
      </template>

      <main v-if="$page.props.result.length > 0">
        <!-- {{ $page.props.result }} -->
        <div
          class="rebates_record"
          :key="result.batch + '_' + index"
          v-for="(result, index) in $page.props.result"
        >
          <div>
            <div class="label">結算週期</div>
            {{ result.batch }}
          </div>

          <div class="cv">
            <div>
              <div class="label">自身消費</div>
              {{ result.self | commaFormat }}
            </div>
            <div class="whitespace-nowrap text-sm">
              x {{ result.self_percentage }}%
            </div>
          </div>

          <div class="cv">
            <div>
              <div class="label">已推薦成員消費</div>
              {{ result.referred | commaFormat }}
            </div>
            <div class="whitespace-nowrap text-sm">
              x {{ result.referred_percentage }}%
            </div>
          </div>

          <div class="cv">
            <div class="text-bold text-sm">＝</div>
            <div>
              <div class="label" v-if="route().current('user.rebates.rebate')">
                獎勵金
              </div>
              <div class="label" v-else>購物金</div>
              {{ result.amount }}
            </div>
          </div>
        </div>
      </main>
      <main v-else>
        <div class="text-center" v-if="route().current('user.rebates.rebate')">
          沒有任何獎勵金明細資料。
        </div>
        <div class="text-center" v-else>沒有任何購物金明細資料。</div>
      </main>
    </rebate-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import RebateTemplate from "./Shared/RebateTemplate";

export default {
  components: {
    RebateTemplate,
  },
  filters: {
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  layout: Layout,
  data() {
    return {
      //
    };
  },
};
</script>

<style lang="postcss">
.rebates_record {
  @apply flex justify-between flex-col md:flex-row border border-fh-gray-border items-center p-5 m-2 gap-2;
}

.rebates_record .cv {
  @apply flex flex-row flex-nowrap gap-2 items-center w-24;
}

.rebates_record .label {
  @apply text-sm whitespace-nowrap;
}
</style>